import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import axios from './plugins/axios'
import store from "./store/index";
import '@babel/polyfill'
import { hasAnyOfRequiredPermission, hasAllRequiredPermission } from './utils/utils';

// グローバルメソッド登録
Vue.prototype.$hasAnyOfRequiredPermission = hasAnyOfRequiredPermission;
Vue.prototype.$hasAllRequiredPermission = hasAllRequiredPermission;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.prototype.$axios = axios
